<template>
  <HKLModal
    ref="retFinalPayModal"
    class="retention-final-confirm-modal"
    :hasCancelBtn="false"
    okBtnAction="ok"
    :beforeOkClick="handleBeforeDecisionOk"
  >
    <FinalPaymentModalTemplate />
    <div class="final-payment-decisions">
      <HKLRadioButton
        v-for="decision in decisions"
        :key="decision.value"
        v-model="selectedDecision"
        class="final-payment-decisions__option"
        :value="decision.value"
      >
        {{ $t(decision.label) }}
      </HKLRadioButton>
    </div>
  </HKLModal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import mutationTypes from '@/store/mutation-types'
import EventBus from '@/utils/eventBus'
import HKLRadioButton from '@/controls/Button/HKLRadioButton'
import HKLModal from '@/controls/Modal/HKLModal'
import FinalPaymentModalTemplate from '@/modules/projects/submission-request/FinalPaymentModalTemplate.vue'
import { completionType } from '@/utils/locale'

const FinalPaymentDecision = Object.freeze({
  FINAL: 'final',
  CONTINUE: 'continue',
  CANCEL: 'cancel',
})

export default {
  components: {
    HKLRadioButton,
    HKLModal,
    FinalPaymentModalTemplate,
  },
  props: {
    afterConfirm: {
      type: Function,
      default: () => {},
    },
    srIndex: {
      type: Number,
      default: 0,
    },
    submission: {
      type: Object,
      default () { return {} },
    },
    eventId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      selectedDecision: '',
      decisions: [
        {
          value: FinalPaymentDecision.FINAL,
          label: 'hint.finalPaymentModal.acceptAsFinalPayment',
        },
        {
          value: FinalPaymentDecision.CONTINUE,
          label: 'hint.finalPaymentModal.acceptWithNewSubmission',
        },
        {
          value: FinalPaymentDecision.CANCEL,
          label: 'hint.finalPaymentModal.cancelAndGoBack',
        },
      ],
    }
  },
  methods: {
    ...mapMutations('projects', {
      updateProjectField: mutationTypes.UPDATE_PATH_FIELD,
    }),
    ...mapActions('projects', [
      'saveSubmission',
      'loadProject',
    ]),
    open () {
      this.selectedDecision = ''
      this.$refs.retFinalPayModal.open()
    },
    close () {
      this.$refs.retFinalPayModal.close()
    },
    async handleBeforeDecisionOk () {
      if (this.selectedDecision === FinalPaymentDecision.CANCEL) {
        return true
      }
      if (this.selectedDecision === FinalPaymentDecision.CONTINUE) {
        await this.acceptWithNewSubmission()
        return true
      }
      if (this.selectedDecision !== FinalPaymentDecision.FINAL) {
        return false
      }

      const type = completionType.FINAL_PAYMENT
      await this.updateSubmission(type)
      this.afterConfirm()
      return true
    },
    async acceptWithNewSubmission () {
      const type = completionType.RETENTION_PAYMENT
      await this.updateSubmission(type)
      EventBus.emit(`rate_or_final_modal_update_submission_${this.eventId}`)
    },
    setCompletionTypeAsFinal (completionType) {
      const path = ['submissions', this.srIndex, 'completionType']
      this.updateProjectField({ path, newValue: completionType })
    },

    async updateSubmission (completionType) {
      this.setCompletionTypeAsFinal(completionType)
      if (this.submission.id) {
        const submissionAttr = {
          id: this.submission.id,
          completionType}
        await this.saveSubmission({ submission: submissionAttr, showNotification: false })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.final-payment-decisions {
  margin-top: 20px;

  &__option + &__option {
    margin-top: 12px;
  }
}
</style>
